module.exports = __webpack_public_path__ + "static/media/recent-three.2485e84e.png";